import { render, staticRenderFns } from "./MaintenanceView.vue?vue&type=template&id=72c3b594&scoped=true&"
import script from "./MaintenanceView.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceView.vue?vue&type=script&lang=ts&"
import style0 from "./MaintenanceView.vue?vue&type=style&index=0&id=72c3b594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3b594",
  null
  
)

export default component.exports